export default "__VITE_ASSET__BadQ5F1T__"